<template>
  <div class="table-overflow-hide">
    <div class="directoryTable scrollable-55vh">
      <table class="table">
        <thead class="sticky-header">
          <tr>
            <th class="icon-col"></th>
            <th>District</th>
            <th>School Name</th>
            <th class="icon-col">&nbsp;</th>
            <th>District ID</th>
            <th>School ID</th>
            <th>Subdomain</th>
            <th>Expiration Date</th>
            <th class="icon-col">
              <v-btn
                @click="schoolStore.schools.reload()"
                icon
                color="gray200"
                size="x-small"
                :loading="schoolStore.schools.loading"
                style="max-width: 20px; max-height: 20px"
              >
                <v-icon>mdi-reload</v-icon></v-btn
              >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in paginatedResults"
            :key="row.uid"
            :class="{
              'table-row': true
            }"
          >
            <td>
              <v-btn color="gray300" density="compact" icon variant="text" :disabled="deleted">
                <v-tooltip location="bottom" class="custom-tooltip" activator="parent">
                  Status: {{ row.status?.status }}
                </v-tooltip>
                <v-icon v-if="row.status?.status == 'active'" color="green"
                  >mdi-check-circle-outline</v-icon
                >
                <v-icon v-else-if="row.status?.status == 'inactive'"
                  >mdi-check-circle-outline</v-icon
                >
                <v-icon v-else-if="row.status?.status == 'trial'" color="yellow"
                  >mdi-clock-alert-outline</v-icon
                >
                <v-icon v-else-if="row.status?.status == 'deleted'" color="red">mdi-cancel</v-icon>
              </v-btn>
            </td>
            <td data-cy="table-col-name">{{ row.district?.district_name }}</td>
            <td data-cy="table-col-name">{{ row.school_name }}</td>

            <td>
              <v-btn
                data-cy="directory-impersonate-btn"
                @click="impersonate(row.username, row.district_id, row.school_id, row.subdomain, row.is_district)"
                :loading="state.loadImpersonate.includes(row.username)"
                color="gray300"
                density="compact"
                icon
                variant="text"
                :disabled="deleted"
              >
                <v-tooltip activator="parent" location="bottom">Log in as this school</v-tooltip>
                <v-icon color="gray500">mdi-security</v-icon>
              </v-btn>
            </td>
            <td data-cy="table-col-name">{{ row.district_id }}</td>
            <td data-cy="table-col-name">{{ row.school_id }}</td>
            <td data-cy="table-col-name">{{ row.subdomain }}</td>
            <td
              data-cy="table-col-name"
              :style="{ color: isSchoolExpired(row.status?.expiration_date) ? 'red' : '' }"
            >
              {{ row.status?.expiration_date }}
            </td>

            <td data-cy="table-col-name">
              <!-- <span class="d-flex align-center justify-content-center gap-3"> -->
              <v-btn
                color="gray300"
                density="compact"
                icon
                variant="text"
                @click="
                  editModal.show = true;
                  editModal.school = row;
                "
              >
                <v-icon color="gray500">mdi-note-edit</v-icon>
              </v-btn>
              <!-- </span> -->
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="schoolStore.schools.loading && !schoolStore.schools.data.length"
        style="
          height: calc(100% - 60px);
          background-color: rgba(246, 247, 237, 0.5);
          border-radius: 15px;
        "
      >
        <LoadingState text="Loading Schools"></LoadingState>
      </div>
      <div
        v-if="!schoolStore.schools.loading && !schoolStore.schools.data.length"
        style="
          height: calc(100% - 60px);
          background-color: rgba(246, 247, 237, 0.5);
          border-radius: 15px;
        "
      >
        <div class="empty-state">
          <figure style="max-width: 300px">
            <IconListEmptyState />
          </figure>
          <div class="title">We couldn't find any Schools.</div>
          <p>Try reloading the page or adding a new schools.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="table-pagination-btns">
    <pagination
      v-model:curr-page="currPage"
      v-model:per-page="perPage"
      :page-status-text="pageStatusText"
      :total-pages="totalPages"
      @page-down="pageDown"
      @page-up="pageUp"
    ></pagination>
  </div>
  <EditSchoolModal v-model:show="editModal.show" :school="editModal.school" />
</template>

<script setup lang="ts">
import { reactive } from "vue";
import usePaginate from "@/hooks/usePaginate";
import { computed } from "vue";
import pagination from "@/components/pagination.vue";
import type { GetSchoolDetails } from "@/api_types/school";
import { complexSearch } from "@/utils";

import useSchools from "@/stores/support/schools";
import FetchService from "@/services/fetch.service";
import { useAuthenticationStore } from "@/stores/authentication";
import authService from "@/services/auth.service";
import { useAlertsStore } from "@/stores/alerts";
import LoadingState from "@/components/loadingState.vue";
import IconListEmptyState from "@/assets/icons/list-empty-state.svg";
import dayjs from "dayjs";
// @ts-ignore
import EditSchoolModal from "@/components/support/editSchoolModal.vue";
const props = defineProps<{
  search: string;
  deleted: boolean;
}>();
defineEmits<{
  (e: 'update:search', ...args: any[]): void
}>();
const editModal = reactive({ show: false, school: {} as GetSchoolDetails });

const authStore = useAuthenticationStore();

const state = reactive({
  loadImpersonate: [] as string[],

  loadPinned: [] as string[],
  loadDownload: false
});

const schoolStore = useSchools();
// parentsS.parents.reload();
const filteredData = computed(() => {
  return (
    schoolStore.schools.data?.filter((i) => {
      // console.log(i);
      if (i.deleted !== props.deleted) return false;
      // if (props.deleted ) return false;
      // return complexSearch(props.search || "", `${i.school_name}`);
      if (complexSearch(props.search || "", `${i.school_name}`) || complexSearch(props.search || "", `${i.district_name}`) || complexSearch(props.search || "", `${i.subdomain}`) || complexSearch(props.search || "", `${i.school_id}`) || complexSearch(props.search || "", `${i.district_id}`))
        return true;
      else
        return false;
    }) || []
  );
});

const { currPage, perPage, pageStatusText, totalPages, pageDown, pageUp, paginatedResults } =
  usePaginate(filteredData);

const isSchoolExpired = (exp_date) => {
  return dayjs(exp_date).isBefore(dayjs());
};

// Usa

const impersonate = async (username, district_id, school_id, account, is_district) => {
  state.loadImpersonate.push(username);
  let type = 'school';
  if (is_district == 'yes'){
    type = 'district';
  }
  try {
    const res = await FetchService.fetchData(
      `/impersonate?uid=${username}&district_id=${district_id}&school_id=${school_id}&type=${type}`,
      "get"
    );
    if (!res) throw "Failed";
    const data = authService.parseJwt(res, false);    
    const tokenName = `ptcwizard_${account}_school_jwt`;
    localStorage.setItem(tokenName, JSON.stringify(data));
    window.open(`/${account}/school`, "_blank");
  } catch (error) {
    useAlertsStore().addAlert("error", "Failed to impersonate school, please try again later");
  }
  state.loadImpersonate = state.loadImpersonate.filter((str) => str !== username);
};
</script>
<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
.scrollable {
  max-height: 55vh;
  height: 55vh;
  overflow: scroll;
}

.icon-col {
  width: 0px;
}

.table-row {
  td {
    transition: background-color 0.3s;
  }
  &.selected {
    td {
      background-color: #e6e6e689 !important;
    }
  }
}
</style>
